// NAAT Error Code Mapping (Business translations)
export const NAAT_ERROR_MESSAGES: Record<string, string> = {
  // Risk-Level Errors
  TAMP_FOTO_RISK: 'Photo tampering risk',
  TAMP_DATA_RISK: 'Data tampering risk',
  HOLOGRAM_RISK: 'Hologram risk',
  ORIGINAL_RISK: 'Originality risk',
  COPY_RISK: 'Detected copy risk',
  PHOTO_OF_A_DEVICE_RISK: 'Photo of a device risk',
  TOO_MUCH_LIGHT_RISK: 'Too much light to evaluate risk',
  TOO_LITTLE_LIGHT_RISK: 'Too little light to evaluate risk',
  DAMAGED_RISK: 'Too damaged to evaluate risk',
  INVALID_COLORS_RISK: 'Colors do not match risk',
  DATA_OBSTRUCTION_RISK: 'Data obstruction risk',
  EXPIRED_RISK: 'Not valid (expired) risk',
  // Detection-Level Errors
  TAMP_FOTO_DETECTED: 'Photo tampering detected',
  TAMP_DATA_DETECTED: 'Data tampering detected',
  NO_HOLOGRAM: 'No hologram present',
  NO_ORIGINAL: 'Not original',
  COPY_DETECTED: 'Copy detected',
  PHOTO_OF_A_DEVICE: 'Photo of a device',
  TOO_MUCH_LIGHT: 'Too much light to evaluate',
  TOO_LITTLE_LIGHT: 'Too little light to evaluate',
  DAMAGED: 'Too damaged',
  INVALID_COLORS: 'Colors do not match',
  DATA_OBSTRUCTION: 'Data obstruction',
  EXPIRED: 'Not valid',
  BLURRY: 'Blurry ID',
  ONLY_ONE_SIDE: 'Only one side',
  ID_NOT_ALLOWED: 'Identification not allowed',
};
